import { useMemo } from 'react';
import { AuditionPhase } from 'shared/enums/AuditionPhase';
import { AuditionStatus } from 'shared/enums/AuditionStatus';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';

const { getAuditionRequest, getAuditionSchedules } = auditionScheduleService();

export const useAuditionData = () => {
  const { data: pending, isLoading: pendingLoading } = getAuditionSchedules({
    phase: AuditionPhase.SELF_TAPES_PROCESS,
    status: AuditionStatus.PENDING,
  });

  const { data: completed, isLoading: completedLoading } = getAuditionRequest({
    status: AuditionStatus.COMPLETED,
    phase: AuditionPhase.SUBMISSION,
  });

  const { data: declined, isLoading: declinedLoading } = getAuditionRequest({
    status: AuditionStatus.DECLINED,
    phase: AuditionPhase.SUBMISSION,
  });

  const { data: pastST, isLoading: pastSTLoading } = getAuditionRequest({
    status: AuditionStatus.COMPLETED,
    phase: AuditionPhase.SELF_TAPES,
  });

  const { data: declinedSTdata, isLoading: isDeclineSTLoading } = getAuditionRequest({
    status: AuditionStatus.DECLINED,
    phase: AuditionPhase.SELF_TAPES,
  });

  const { data: audReq, isLoading: audReqLoading } = getAuditionRequest({});

  const { data: upAud, isLoading: upAudLoading } = getAuditionSchedules({
    phase: AuditionPhase.SUBMISSION,
    status: AuditionStatus.CONFIRMED,
  });

  const { data: upcomingSelfTapesData, isLoading: upcomingSelfTapesLoading } = getAuditionSchedules({
    phase: AuditionPhase.SELF_TAPES,
    status: AuditionStatus.CONFIRMED,
  });

  const auditionRequest = useMemo(() => {
    if (audReqLoading) {
      return;
    } else {
      return audReq
        ? audReq.pages
            .filter((v, index) => index === 0)
            .map((i) => i.data.audition_schedule_requests_connection.nodes)[0]
        : undefined;
    }
  }, [audReq, audReqLoading]);

  const pendingAudition = useMemo(() => {
    if (pendingLoading) {
      return;
    } else {
      return pending
        ? pending.pages
            .filter((v, index) => index === 0)
            .map((i) => i.data.talent_audition_schedules_connection.nodes)[0]
        : undefined;
    }
  }, [pending, pendingLoading]);

  const completedAudition = useMemo(() => {
    if (completedLoading) {
      return;
    } else {
      return completed
        ? completed.pages
            .filter((v, index) => index === 0)
            .map((i) => i.data.audition_schedule_requests_connection.nodes)[0]
        : undefined;
    }
  }, [completed, completedLoading]);

  const pastSelftapes = useMemo(() => {
    if (pastSTLoading) {
      return;
    } else {
      return pastST
        ? pastST.pages
            .filter((v, index) => index === 0)
            .map((i) => i.data.audition_schedule_requests_connection.nodes)[0]
        : undefined;
    }
  }, [pastST, pastSTLoading]);

  const declinedST = useMemo(() => {
    if (isDeclineSTLoading) {
      return;
    } else {
      return declinedSTdata
        ? declinedSTdata.pages
            .filter((v, index) => index === 0)
            .map((i) => i.data.audition_schedule_requests_connection.nodes)[0]
        : undefined;
    }
  }, [declinedSTdata, isDeclineSTLoading]);

  const declinedAudition = useMemo(() => {
    if (declinedLoading) {
      return;
    } else {
      return declined
        ? declined.pages
            .filter((v, index) => index === 0)
            .map((i) => i.data.audition_schedule_requests_connection.nodes)[0]
        : undefined;
    }
  }, [declined, declinedLoading]);

  const upcomingAudition = useMemo(() => {
    if (upAudLoading) {
      return;
    } else {
      return upAud
        ? upAud.pages.filter((v, index) => index === 0).map((i) => i.data.talent_audition_schedules_connection.nodes)[0]
        : undefined;
    }
  }, [upAud, upAudLoading]);

  const upcomingSelfTapes = useMemo(() => {
    return upcomingSelfTapesData
      ? upcomingSelfTapesData.pages
          .filter((v, index) => index === 0)
          .map((i) => i.data.talent_audition_schedules_connection.nodes)[0]
      : undefined;
  }, [upcomingSelfTapesData]);

  // const selftapesRequests = auditionRequest?.filter((a) => a.phase === AuditionPhase.SELF_TAPES)

  return {
    pendingAudition,
    pendingLoading,
    auditionRequest,
    completedAudition,
    declinedAudition,
    upcomingAudition,
    upcomingSelfTapes,
    upAudLoading,
    audReqLoading,
    upcomingSelfTapesLoading,
    pastSelftapes,
    pastSTLoading,
    completedLoading,
    declinedLoading,
    declinedST,
    isDeclineSTLoading,
  };
};
